import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuickDonateCarouselComponent } from './quicdonate_carousel.component';
import { MatButtonModule } from '@angular/material/button';
import { NgxGlideModule } from 'ngx-glide';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { PaymentSipUpiTimerModule } from '../payment-sip-upi-timer/payment-sip-upi-timer.module';

@NgModule({
  declarations: [
    QuickDonateCarouselComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    NgxGlideModule,
    SharedModule,
    MatIconModule,
    PaymentSipUpiTimerModule
  ],
  exports: [
    QuickDonateCarouselComponent
  ],
  bootstrap: [
    QuickDonateCarouselComponent
  ]
})
export class QuickDonateCarouselModule {
  getComponent() {
    return QuickDonateCarouselComponent;
  }
}
